// extracted by mini-css-extract-plugin
export default {"link":"_ecDs","linkArrow":"BK7Q4","button":"Sp2A9","title":"VHO6Z"};